import React from 'react';
import { useSessionMonitor } from '@/hooks/useSessionMonitor';

/**
 * SessionMonitor Component
 *
 * Monitors session expiration and shows warnings to the user.
 * - Checks session every 60 seconds
 * - Shows warning toast 5 minutes before expiry
 * - Shows critical warning toast 1 minute before expiry
 * - Allows user to refresh session from warning toast
 */
export const SessionMonitor: React.FC = () => {
  // Hook handles all the monitoring and notifications
  useSessionMonitor();

  // This component doesn't render anything visible
  return null;
};
